import { NewVersionAlert } from "./NewVersionAlert";
import { useVersionCheck } from "./useVersionCheck";
import { useFormatMessage } from "../intl";

type Props = {
  children: JSX.Element;
};

export function VersionChecker(props: Props) {
  const { shouldShowNewVersionAlert, onCancelAlert } = useVersionCheck();
  const formatMessage = useFormatMessage();

  return (
    <>
      {shouldShowNewVersionAlert && (
        <NewVersionAlert
          onCancel={onCancelAlert}
          onDismiss={onCancelAlert}
          ariaLabel={formatMessage("Modal.closeButton")}
        />
      )}
      {props.children}
    </>
  );
}
